import { Menu, MenuButton, MenuItems } from '@headlessui/react';
import Checkbox from 'components/shared/Checkbox';
import { replicaStore } from 'entities/tavus/replica/model/replicaStore';
import { TRatioReplicaType } from 'entities/tavus/replica';
import { Chevron } from '@livekit/components-react';
import { cn } from 'shared/lib';

export const FiltersDropdown = () => {
  const { setRatioFilters, ratioFilters } = replicaStore();

  const renderMenuItems = (items: { label: string; value: string }[]) => (
    <div className="ag-flex ag-flex-col ag-items-start ag-gap-1 ag-justify-evenly">
      {items.map((item) => (
        <Checkbox
          key={item.value}
          label={item.label}
          onClick={(value) => setRatioFilters(value as TRatioReplicaType)}
          choosenValues={ratioFilters}
          value={item.value}
        />
      ))}
    </div>
  );

  const renderMenu = (
    placeholder: string,
    items: { label: string; value: string }[]
  ) => (
    <Menu as="div" className="ag-relative ag-w-full lg:ag-w-auto">
      {({ open }) => (
        <>
          <MenuButton className="ag-w-full lg:ag-w-[90px] ag-h-10 ag-border-neutral-300 ag-flex ag-justify-center ag-items-center ag-rounded-md ag-border">
            <div className="ag-text-sm ag-font-inter ag-font-medium ag-text-neutral-600 ag-flex ag-flex-row ag-items-center ag-gap-1">
              {placeholder}
              <Chevron
                className={cn(open ? 'ag-rotate-[270deg]' : 'ag-rotate-90')}
              />
            </div>
          </MenuButton>

          {open && (
            <MenuItems
              as="div"
              style={{ zIndex: '99999' }}
              className="ag-absolute ag-right-0 ag-w-full lg:ag-w-48 ag-bg-white ag-border ag-border-neutral-300 ag-rounded-md ag-overflow-hidden ag-mt-1 ag-p-1 ag-shadow-lg ag-text-neutral-900"
            >
              {renderMenuItems(items)}
            </MenuItems>
          )}
        </>
      )}
    </Menu>
  );

  return (
    <div className="ag-flex ag-gap-4">
      {renderMenu('Type', [
        { label: 'Full Body', value: 'Full Body' },
        { label: 'Half Body', value: 'Half Body' }
      ])}
      {renderMenu('Style', [
        { label: 'Video Call', value: 'Video Call' },
        { label: 'Vertical Selfie', value: 'Vertical Selfie' }
      ])}
    </div>
  );
};
